import { render, staticRenderFns } from "./LoginRoot.vue?vue&type=template&id=49435164&scoped=true"
import script from "./LoginRoot.vue?vue&type=script&lang=js"
export * from "./LoginRoot.vue?vue&type=script&lang=js"
import style0 from "./LoginRoot.vue?vue&type=style&index=0&id=49435164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49435164",
  null
  
)

export default component.exports